import React from 'react';
import { useTranslation } from 'react-i18next';
import './style.css';
import imgGraph from '../../img/home/benefits_website.webp';
import ArrowRight from '../../img/ui/ui-arrow-top-right.svg';

const BenefitsSection = () => {
  const { t } = useTranslation('home');

  return (
    <section className="benefits section">
      <div className="container">
        <div className="benefits__wrapper">
          <div className="benefits__text-block">
            <h2 className="title-2">
              {t('benefits.title')} <span className="accent">{t('benefits.titleAccent')}</span> {t('benefits.titleEnd')}
            </h2>
            <h3 className="benefits__subtitle">{t('benefits.subtitle')}</h3>
            <ul>
              {t('benefits.items', { returnObjects: true }).map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
            <div className="benefits__button">
              <a href="/prices" className="button">
                {t('common:buttons.findPlan')}
                <img src={ArrowRight} alt="" aria-hidden="true" width={10} height={11} />
              </a>
            </div>
          </div>

          <div className="benefits__image-block">
            <img
              src={imgGraph}
              alt={t('benefits.imageAlt')}
              width={1536}
              height={1024}
              loading="lazy"
              className="main-image"
            />
            <div className="benefits__statistic-block">
              <div className="benefits__circle-container">
                <div className="circle-progress"></div>
                <div className="circle-text">+86%</div>
              </div>
              <p>{t('benefits.statLabel')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
